import { render, staticRenderFns } from "./VendorList.vue?vue&type=template&id=af6e9b3c&scoped=true&"
import script from "./VendorList.vue?vue&type=script&lang=js&"
export * from "./VendorList.vue?vue&type=script&lang=js&"
import style0 from "./VendorList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./VendorList.vue?vue&type=style&index=1&id=af6e9b3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6e9b3c",
  null
  
)

component.options.__file = "VendorList.vue"
export default component.exports